import _ from 'lodash';
import Slot from './Slot';
import Utils from '../utils/Utils';
import SoundManager from '../utils/SoundManager';

const LINES = {
    0: [5,6,7,8,9],
    1: [0,1,2,3,4],
    2: [10,11,12,13,14],
    3: [0,6,12,8,4],
    4: [10,6,2,8,14],
    5: [5,11,12,13,9],
    6: [5,1,2,3,9],
    7: [10,6,7,8,14],
    8: [0,6,7,8,4],
    9: [5,1,7,3,9],
    10: [5,11,7,13,9],
    11: [0,11,2,13,4],
    12: [10,1,12,3,14],
    13: [5,6,2,8,9],
    14: [5,6,12,8,9],
    15: [10,1,2,3,14],
    16: [0,11,12,13,4],
    17: [10,6,12,8,14],
    18: [0,6,2,8,4],
    19: [0,1,7,3,4],
    20: [10,11,7,13,14],
    21: [5,1,12,3,9],
    22: [5,11,2,13,9],
    23: [0,1,7,13,14],
    24: [10,11,7,3,4]
};


export default class Slots extends Phaser.Group {

    /**
     * Constructor
     * @param game
     * @param cellModels
     */
    constructor(game, { cellModels } = {})
    {
        super(game);

        if (!this._checkCellModels(cellModels))
        {
            throw new Error('Invalid initial cell models for slots.');
        }

        let cellsContaner = this._cellsContainer = new Phaser.Group(game);
        this.addChild(cellsContaner);

        let strokeContainer = this._strokeContainer = new Phaser.Group(game);
        this.addChild(strokeContainer);

        let dX = 0;
        let slotViews = this._slotViews = [];
        for (let i = 0; i < 5; i++)
        {
            let slotView = new Slot(game, { cellModels: cellModels.filter((model) => model.slotIndex === i) });
            slotView.position.set(dX, 0);
            dX += slotView.width + 4;
            cellsContaner.addChild(slotView);
            slotViews.push(slotView);
        }
    }

    _checkCellModels(cellModels)
    {
        return cellModels && cellModels.length;
    }

    setCells( cellModels )
    {
        this._slotViews.forEach((slotView)=>
        {
            slotView.setCells( cellModels.filter((cellModel) => cellModel.slotIndex === slotView.slotIndex ) );
        });
    }
    
    transformTo(cellModels)
    {
        let promises = cellModels.map((model) =>
        {
            return this._slotViews[model.slotIndex].transformTo(model);
        });

        return Promise.all(promises);
    }

    spinTo(cellModels, extraSpinSlotIndexes = [])
    {
        if (!this._checkCellModels(cellModels))
        {
            return Promise.reject('Invalid cell models for slots.');
        }

        let strokeContainer = this._strokeContainer;
        strokeContainer.removeAll(true);

        const baseSpinsBeforeStop = 1;

        let delay = 100;
        let promises = this._slotViews.map((slotView, slotIndex) =>
        {
            let models = cellModels.filter((model) => model.slotIndex === slotIndex);
            let promise = slotView.spinTo(models, delay, baseSpinsBeforeStop + slotIndex, extraSpinSlotIndexes.indexOf(slotIndex) !== -1);
            //delay += _.random(150, 300);

            return promise;
        });

        return Promise.all(promises);
    }

    strokeLine(line, time, color, resetHighlight = true)
    {
        const strokeContainer = this._strokeContainer;
        const cellsContainerBounds = this._cellsContainer.getBounds();
        
        const strokePoints = [];
        const slotWidth = this._slotViews[1].x - this._slotViews[0].x;
        const cellHeight = 140;
        let hightlightCells = [];
        LINES[line].forEach((cellIndex) =>
        {
            const slotIndex = cellIndex % 5;
            cellIndex = Math.floor(cellIndex / 5);

            strokePoints.push(new Phaser.Point(
                slotIndex * slotWidth + (slotWidth >> 1),
                10 + cellIndex * cellHeight + (cellHeight >> 1)
            ));

            const slotView = this._slotViews[slotIndex];
            let cellViews = slotView.cellViews;
            cellViews = cellViews.filter((cellView) =>
            {
                const cellModel = cellView.model;
                return cellModel.highlight &&
                    cellModel.type === 'regular' &&
                    cellModel.slotIndex === slotIndex &&
                    cellModel.cellIndex === cellIndex;
            });

            hightlightCells.push(...cellViews);
        });


        if (resetHighlight)
        {
            this._slotViews.forEach((slotView) =>
            {
                const cellViews = slotView.cellViews;
                cellViews.forEach((cellView) =>
                {
                    cellView.stop('frame');
                });
            });

            hightlightCells.forEach((cellView) =>
            {
                cellView.hightlight();
            });
        }


        const lines = new Phaser.Graphics(this.game, 0, 0);
        lines.lineStyle(6, color);
        lines.drawPolygon(new Phaser.Polygon(strokePoints));
        strokeContainer.addChild(lines);

        // resolve immediatelly if timeout equals 0
        if (time === 0/*indefinitely*/)
        {
            return Promise.resolve();
        }
            
        return Utils.makeTimeoutPromise(time).then(() =>
        {
            strokeContainer.remove(lines, true);
            return Promise.resolve();
        });        
    }
    
    strokeLines(lines, time)
    {
        const strokeContainer = this._strokeContainer;
        strokeContainer.removeAll(true);

        let COLORS = [
            0x8DB600, // 1. Apple Green
            0xFF033E, // 2. American Rose
            0x007FFF, // 3. Azure
            0xC39953, // 4. Aztec Gold
            0x89CFF0, // 5. Baby Blue
            0xE3DAC9, // 6. Bone
            0xDE5D83, // 7. Blush
            0xB5A642, // 8. Brass
            0xFFF600, // 9. Cadmium Yellow
            0x4B3621, // 10. Café Noir
            0x00563F, // 11.Castleton Green
            0xC95A49, // 12.Cedar Chest
            0x007AA5, // 13.CG Blue
            0x36454F, // 14.Charcoal
            0xD2691E, // 15.Chocolate (Web)
            0xFBEC5D, // 16.Corn
            0xFF4040, // 17.Coral Red
            0x188BC2, // 18.Cyan Cornflower Blue
            0x9932CC, // 19.Dark Orchid
            0xE75480, // 20.Dark Pink
            0x8FBC8F, // 21.Dark Sea Green
            0xD70A53, // 22.Debian Red
            0xFF1493, // 23.Deep Pink
            0x1034A6, // 24.Egyptian Blue
            0xCCFF00  // 25.Fluorescent Yellow
        ].sort(() => 0.5 - Math.random());

        return Promise.all(
            lines.map((line) => this.strokeLine(line, time, COLORS.pop()), lines.length > 1)
        ); 
    }
    
    hideLines()
    {
        this._strokeContainer.removeAll( true );    
    }
    
    animateStrokeLines(lines)
    {
        this._slotViews.forEach((slotView) =>
        {
           const cellViews = slotView.cellViews;
            cellViews.forEach((cellView) =>
            {
                cellView.stop('loop');
            });
        });

        // stop previous
        this.stopStrokeLinesAnimation();

        if (!lines.length)
        {
            return;
        }

        let COLORS = [
            0x8DB600, // 1. Apple Green
            0xFF033E, // 2. American Rose
            0x007FFF, // 3. Azure
            0xC39953, // 4. Aztec Gold
            0x89CFF0, // 5. Baby Blue
            0xE3DAC9, // 6. Bone
            0xDE5D83, // 7. Blush
            0xB5A642, // 8. Brass
            0xFFF600, // 9. Cadmium Yellow
            0x4B3621, // 10. Café Noir
            0x00563F, // 11.Castleton Green
            0xC95A49, // 12.Cedar Chest
            0x007AA5, // 13.CG Blue
            0x36454F, // 14.Charcoal
            0xD2691E, // 15.Chocolate (Web)
            0xFBEC5D, // 16.Corn
            0xFF4040, // 17.Coral Red
            0x188BC2, // 18.Cyan Cornflower Blue
            0x9932CC, // 19.Dark Orchid
            0xE75480, // 20.Dark Pink
            0x8FBC8F, // 21.Dark Sea Green
            0xD70A53, // 22.Debian Red
            0xFF1493, // 23.Deep Pink
            0x1034A6, // 24.Egyptian Blue
            0xCCFF00  // 25.Fluorescent Yellow
        ].sort(() => 0.5 - Math.random()).slice(0, lines.length);

        let currentLine = 0;
        this._strokeContainer.removeAll(true);
        this.strokeLine(lines[currentLine], 0/*indefinitely*/, COLORS[0]);

        this.strokeLinesTimerId = setInterval(() =>
        {
            this.hideLines();
            const color = COLORS.pop();
            COLORS.unshift(color);
            currentLine = (currentLine + 1) % lines.length;
            this.strokeLine(lines[currentLine], 0/*indefinitely*/, color, lines.length > 1);
        }, 1500);
    }
    
    stopStrokeLinesAnimation()
    {
        clearInterval(this.strokeLinesTimerId);
        this.strokeLinesTimerId = null;
        this._strokeContainer.removeAll(true);
    }
    
    strokeCells(cellModels, time = 2000)
    {
        const strokeContainer = this._strokeContainer;
        const cellsContainerBounds = this._cellsContainer.getBounds();
        let cellViews = this._slotViews.map((slotView) =>
        {
           return slotView.cellViews;
        });

        cellViews = _.flatten(cellViews);
        cellViews = cellViews
            .filter((cellView) =>
            {
                return cellModels.some((cellModel) => cellModel.compare(cellView.model));
            })
            .sort((cellViewA, cellViewB) =>
            {
                return cellViewA.model.slotIndex - cellViewB.model.slotIndex;
            });

        const strokePoints = [];
        cellViews.forEach((cellView) =>
        {
            let cellViewBounds = cellView.getBounds();
            cellViewBounds.x /= this.scale.x;
            cellViewBounds.y /= this.scale.y;
            cellViewBounds.width /= this.scale.x;
            cellViewBounds.height /= this.scale.y;
            strokePoints.push(new Phaser.Point(
                cellViewBounds.x + (cellViewBounds.width >> 1),
                cellViewBounds.y + (cellViewBounds.height >> 1)
            ));
        });

        if (!strokePoints.length)
        {
            return Promise.resolve();
        }

        const lines = new Phaser.Graphics(this.game, 0, 0);
        lines.lineStyle(6, 0xFFFFFF);
        lines.drawPolygon(new Phaser.Polygon(strokePoints));
        strokeContainer.position.set(
            -cellsContainerBounds.x,
            -cellsContainerBounds.y / this.scale.y
        );
        strokeContainer.addChild(lines);

        return Utils.makeTimeoutPromise(time)
            .then(() =>
            {
                strokeContainer.remove(lines, true);
                return Promise.resolve();
            });
    }

    strokeWinCells(cellViews)
    {
        let strokeContainer = this._strokeContainer;
        strokeContainer.removeAll(true);

        let strokePoints = [];
        let cellsContainerBounds = this._cellsContainer.getBounds();
        cellViews.forEach((cellView) =>
        {
            if (cellView.model.highlight)
            {
                let cellViewBounds = cellView.getBounds();
                cellViewBounds.x /= this.scale.x;
                cellViewBounds.y /= this.scale.y;
                cellViewBounds.width /= this.scale.x;
                cellViewBounds.height /= this.scale.y;
                strokePoints.push(new Phaser.Point(
                    cellViewBounds.x + (cellViewBounds.width >> 1),
                    cellViewBounds.y + (cellViewBounds.height >> 1)
                ));
            }
        });

        if (!strokePoints.length)
        {
            return Promise.resolve();
        }

        let lines = new Phaser.Graphics(this.game, 0, 0);
        lines.lineStyle(6, 0xFFFFFF);
        lines.drawPolygon(new Phaser.Polygon(strokePoints));
        strokeContainer.position.set(
            -cellsContainerBounds.x,
            -cellsContainerBounds.y / this.scale.y
        );
        strokeContainer.addChild(lines);

        return Promise.resolve();
    }

    highlightCells(cellModels)
    {
        return Promise.all(
            this._slotViews.map((slotView) => slotView.highlightCells(cellModels))
        );
    }

    nudging()
    {
        return Promise.all(
            this._slotViews.map((slotView) => slotView.nudging())
        );
    }

}